import { useAppSelector } from '~/hooks/useAppSelector';

export const useIsParentOfficeSelector = () => {
  const isParentOffice = useAppSelector(
    (state) =>
      state.user?.childOffices?.length > 1 &&
      state.user?.selectedChildOffice?.id === state.user?.user?.id,
  );

  return isParentOffice;
};
